import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import PageContainer from '../../components/common/PageContainer';

const TransactionRules: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContainer
      title={t('settings.content.transactionRules.title')}
      subTitle={t('settings.content.transactionRules.description')}
    >
      {/* Transaction Rules configuration content will be implemented here */}
    </PageContainer>
  );
};

export default TransactionRules;

